import bus from '~/bus'
import {getEventFile} from '~/helpers/eventHelper'

export default {
  name: 'edited',
  do: async function (payload) {
    console.log('DEBUG edited: ', this, payload)
    const file = await getEventFile(payload.deprecated_file_id).then((response) => response)
    if (this.file === payload.file_id || (this.fileAncestors && this.fileAncestors.includes(payload.file_id))) {
      if (payload.description) {
        bus.$emit('refreshRightDrawerDescription', payload)
      } else {
        bus.$emit('refreshRightDrawer', payload)
      }
      bus.$emit('refreshAppbar', file)
    }
    if (this.fileChildren.includes(payload.file_id) || (this.file === 'recent' && payload.recent)) {
      if (payload.description) {
        bus.$emit('refreshRightDrawerDescription', payload)
      } else {
        bus.$emit('refreshRightDrawer', payload)
      }
      bus.$emit('updateFile', file)
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/edited.js